







import {
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import { TicketType } from '@superbet-group/web.types';
import { defineComponent } from '@vue/composition-api';

import { logger } from '@app/logger';
import { RouteName } from '@app/router/constants/RouteName';
import { RecreatableTicket } from '@shared/tickets/RecreatableTicket';
import { BetSlipModule } from '@store/modules/ui/sportOffer/betslip';
import { getFederationComponent } from '@src/federations/getFederationComponent';

export default defineComponent({
    name: 'TicketsWidgetContainer',
    setup() {
        const {
            route,
            router,
        } = useVueRouter();
        const sportOfferRoutes: string[] = [
            RouteName.Sport.PrematchOffer,
            RouteName.Sport.Competition,
            RouteName.App.Home,
        ];

        const sportBetSlipStore = useVuexStore<BetSlipModule>('ui/sportOffer/betSlip');

        const isRecreatingTicket = sportBetSlipStore.getter('isRecreatingTicket');

        const recreateSportTicket = sportBetSlipStore.action('recreateTicket');

        async function recreateTicket(ticket: RecreatableTicket) {
            const currentRoute = route.value.name!;

            try {
                if (ticket.type === TicketType.Sport) {
                    await recreateSportTicket(ticket);
                    if (!sportOfferRoutes.includes(currentRoute)) {
                        return router.value.push({
                            name: RouteName.App.Home,
                        });
                    }
                }
            } catch (error) {
                logger.error(error as Error);
            }
        }

        return {
            isRecreatingTicket,
            recreateTicket,
        };
    },
    components: {
        TicketsWidget: getFederationComponent(() => import('tickets/TicketsWidget')),
    },
});
